import FillHostDetalis from "./FillHostDetalis";
import LeftBox from "./LeftBox";

const FillHost = () => {
    return(
        <div style={{display:"flex"}}>
            <LeftBox />
            <FillHostDetalis />
            </div>
    )
}

export default FillHost;